import { createFileRoute } from "@tanstack/react-router";
import { GeneratePlates } from "../../app/views/elisa/generatePlates";

export const Route = createFileRoute("/elisa/mapplates")({
  component: GeneratePlates,
});
